export const getAuthNavUrl = (responseData = {}) => {
  const roles = (responseData.roles || []).map(Number);
  const access = responseData.businessAccess || responseData.user?.businessAccess;
  const isManager = access?.role === "manager" || access?.isManager === true;
  const hasBusinessUsers = roles.includes(3001);
  const hasBusinessOwnerArea = roles.includes(3000);

  if (isManager || (hasBusinessUsers && !hasBusinessOwnerArea)) {
    return "/business/dashboard";
  }

  return responseData.navUrl || "/";
};
